import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { EstimatePlansV2 } from '../../../estimates/estimate-view/plans/plans-widget/feat-estimate-plans-v2/domain';

@Component({
    selector: 'app-takeoff-plans',
    imports: [NgScrollbarModule, CommonModule],
    templateUrl: './takeoff-plans.component.html',
    styleUrl: './takeoff-plans.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TakeoffPlansComponent {
    selected_iD_Plan = input.required<string>();
    plans = input.required<EstimatePlansV2[] | null>();
    selectedPlanChangeEvent = output<string>();

    onSelectedPlanChanged(selectedPlanId: string) {
        this.selectedPlanChangeEvent.emit(selectedPlanId);
    }
}
